import baseUrl from "./interceptor";

export const getInfoByPolicyNumber = (policyNo, claimNo, isClaimFR) => {
  return baseUrl.get(
    `/claim/policy/info?policyNo=${policyNo}&claimNo=${claimNo}&isClaimFR=${isClaimFR}`,
  );
};

export const getEditClaimInfo = (policyNo) => {
  return baseUrl.get(`/claim/policy/info?claimNo=${policyNo}`);
};

export const getImagingList = (body) => {
  return baseUrl.post("/claim/document/ImaginingList", body);
};

export const getClaimantList = (claimNo, isClaim) => {
  return baseUrl.get(
    `/claim/document/getClaimants?claimNo=${claimNo}&isClaimFR=${isClaim}`,
  );
};

export const getClaimCategory = () => {
  return baseUrl.get(`/claim/document/getCategory`);
};

export const getClaimFormType = () => {
  return baseUrl.get(`/claim/document/getFormType`);
};

export const addNewImging = (form, body) => {
  return baseUrl.post(
    `/claim/document/upload/${form.formDesc}/${form.fileNo}/${form.category}/${form.department}/${form.formType}/${form.claimant}/${form.doNotSendWorkFlow}/${form.perilDesc}/${form.wfClassification}/${form.indexID}`,
    body,
  );
};

export const getClaimantListSerivce = (claimNo, isClaimFR) => {
  return baseUrl.get(
    `claim/claimant/info?claimNo=${claimNo}&isClaimFR=${isClaimFR}`,
  );
};

export const gettClaimantTabsService = (body) => {
  return baseUrl.post("/claim/claimant/tabs/Info", body);
};

export const getClaimFormTypes = () => {
  return baseUrl.get(`/claim/forms/getFormTypes`);
};

export const printClaimForms = (body) => {
  return baseUrl.post(`/claim/forms/generate`, body);
};

export const printClaimFileService = (body) => {
  return baseUrl.post(`/claim/create-pdf`, body);
};
export const getClaimFilePrintStatus = (processId) => {
  return baseUrl.get(`claim/pdf/status?processId=${processId}`);
};

export const getClaimFilePrintPdf = (processId) => {
  return baseUrl.get(`claim/print-pdf?processId=${processId}`, {
    responseType: "blob",
  });
};
export const getClaimFileListService = (claimNo, body) => {
  return baseUrl.post(`/claim/listFile?claimNo=${claimNo}`, body);
};

export const getClaimPrintStatus = (processId) => {
  return baseUrl.get(`claim/forms/status?processId=${processId}`);
};
export const getViewResultStatus = (processId) => {
  return baseUrl.get(`agent-csr/check/statement/status?requestId=${processId}`);
};

export const getClaimPrintFile = (processId) => {
  return baseUrl.get(`claim/forms/getPrint?processId=${processId}`, {
    responseType: "blob",
  });
};
  export const getviewstatementPrint = (processId) => {
    return baseUrl.get(`agent-csr/viewstatement?fileName=${processId}`, {
      responseType: "blob",
    });
  };


export const getClaimsSerive = (claimNo, claimantNo) => {
  return baseUrl.get(`/claim/search/claim?claimNo=${claimNo}`);
};

export const getClaimsCSRSerive = (body) => {
  return baseUrl.post(`/claim/csr`, body);
};
export const getClaimantPeril = (policyNo, vehicleNo) => {
  return baseUrl.get(
    `/claim/claimant/peril?policyNo=${policyNo}&vehicleNo=${vehicleNo}`,
  );
};

export const printNotes = (claimNo, noteIndexID) => {
  return baseUrl.post(
    `/claim/note/print`,
    {
      claimNo: claimNo,
      noteIndexID: noteIndexID,
    },
    {
      responseType: "blob",
    },
  );
};

export const getProviderNotesService = (body) => {
  return baseUrl.post("/claims/provider/view/note", body);
};

export const addProviderNoteService = (body) => {
  return baseUrl.post("/claims/provider/add/note", body);
};

export const printProviderNotes = (internalCode, indexNo) => {
  return baseUrl.get(
    `/claims/provider/print/note?internalCode=${internalCode}`,
    {
      responseType: "blob",
    },
  );
};

export const getNotesService = (body, isPipLog = false) => {
  return baseUrl.post(`/claim/note/details?isPipLog=${isPipLog}`, body);
};

export const getClaimsSUINotesService = (body, isPipLog = false) => {
  return baseUrl.post(`/claim/note/details?isPipLog=${isPipLog}`, body);
};

export const addNoteService = (body) => {
  return baseUrl.post("/claim/note/add", body);
};

export const clearReminder = (indexId) => {
  return baseUrl.patch(`/update/diary?id=${indexId}`);
};

export const addReminder = (body) => {
  return baseUrl.post("/claim/diary/add", body);
};

export const getActiveUsers = () => {
  return baseUrl.get(`get/active/users`);
};

export const getRemindersService = (claimNo, isNonClear = false) => {
  return baseUrl.get(
    `/claim/diary/byClaimNo?claimNo=${claimNo}&isNonClear=${isNonClear}`,
  );
};

export const geSuitsService = (claimNo, claimantNo = 0) => {
  return baseUrl.get(
    `/claim/claimant/suite?claimNo=${claimNo}&claimantNo=${claimantNo}`,
  );
};

export const addSuit = (body) => {
  return baseUrl.post("/claim/claimant/suite/save", body);
};

/**
 * 
 * @param {{
"amount": 100,
"checkNo": "1234",
"claimNo": "DFL-210500003",
"claimant": 1,
"payeeOne": "TEST",
"paymentType": "SUBRO"
}} body 
 * @returns 
 */
export const salSubLaeService = (body) => {
  return baseUrl.post("/claim/claimant/save/salSubLae", body);
};

export const deleteSuit = (indexId) => {
  return baseUrl.delete(`/claim/claimant/suite/delete?indexId=${indexId}`);
};

export const getDocClaimDetails = (indexId) => {
  return baseUrl.get(`/claim/document/details?indexId=${indexId}`);
};

export const getClaimInfoDetailsSerivce = (policyNo, claimNo, isClaimFR) => {
  return baseUrl.get(
    `/claim/infoByClaimNo?policyNo=${policyNo}&claimNo=${claimNo}&isClaimFR=${isClaimFR}`,
  );
};

export const getClaimantInformationService = (
  claimantIndex,
  claimNo,
  isClaimFR,
) => {
  return baseUrl.get(
    `/claim/claimant/info/detail?claimNo=${claimNo}&claimantIndex=${claimantIndex}&isClaimFR=${isClaimFR}`,
  );
};

export const getcompExtService = () => {
  return baseUrl.get(`/claim/claimant/compExt`);
};

export const getClaimantStatusService = () => {
  return baseUrl.get(`/claim/claimant/status`);
};

export const getadAndInjuryListService = () => {
  return baseUrl.get(`/claim/claimant/adAndInjury `);
};

export const getClaimantApiSerivce = (body) => {
  return baseUrl.post(`/claim/payment/`, body);
};

export const getClaimantHistory = (claim, claimantNo) => {
  return baseUrl.get(
    `/claim/claimant/tab/history?claimNo=${claim}&claimantIndex=${claimantNo}`,
  );
};

export const getSubrogationDetails = (claim, claimantNo) => {
  return baseUrl.get(
    `/claim/claimant/subrogation/details?claimNo=${claim}&claimantNo=${claimantNo}`,
  );
};
export const saveClaimFR = (body) => {
  return baseUrl.post("/claim/firstReport/save", body);
};

export const saveClaim = (body, isClaimFR, mode) => {
  return baseUrl.post(
    `/claim/save/Claim?isClaimFR=${isClaimFR}&mode=${mode}`,
    body,
  );
};

export const saveSubrogationDetails = (body) => {
  return baseUrl.post("/claim/claimant/subrogation", body);
};

export const getAdjusterDetails = () => {
  return baseUrl.get(`/claim/claimant/adjuster`);
};

export const getRespondentDetails = () => {
  return baseUrl.get(`/claim/claimant/respCompanies`);
};
export const getsalvageDetailsSerive = (claim, claimantNo) => {
  return baseUrl.get(
    `/claim/claimant/salvage/details?claimNo=${claim}&claimantNo=${claimantNo}`,
  );
};

export const addUpdateSalvage = (body) => {
  return baseUrl.post("/claim/claimant/salvage", body);
};

export const addPipLimitService = (
  claimNo,
  claimantNo,
  pipLimit,
  bypassWarning,
) => {
  return baseUrl.post(
    `/claim/update/pipLimitBtn?claimNo=${claimNo}&claimantNo=${claimantNo}&pipLimit=${pipLimit}&isBypassWarning=${bypassWarning}`,
  );
};

export const getPolicyCSRActiveStatus = (body) => {
  return baseUrl.post("/get/active/policy/page/csr", body);
};

export const getDefaultPerilValues = (body, isInsured = false) => {
  return baseUrl.post(
    `/claim/claimant/defaultAddValues?isInsured=${isInsured}`,
    body,
  );
};

export const getSupervisorOptionsService = () => {
  return baseUrl.get(`/claim/claimant/supervisor`);
};

export const saveProviderService = (body, isNew) => {
  return baseUrl.post(`/claims/provider/add/${isNew}`, body);
};

export const saveProviderLocation = (body) => {
  return baseUrl.post(`/claims/provider/location/add`, body);
};

export const getProviderLocations = (internalCode, fein = "") => {
  return baseUrl.get(
    `/claims/provider/location/view?internalCode=${internalCode}&fein=${fein}`,
  );
};

export const deleteProviderLocation = (indexId) => {
  return baseUrl.delete(`/claims/provider/location/delete?indexId=${indexId}`);
};

export const getProviderDetails = (body) => {
  return baseUrl.post("/claims/provider/csr", body);
};

export const getCodeCsrService = (endpoint, body) => {
  return baseUrl.post(`/claim/invoice/reprice/${endpoint}`, body);
};

export const getPiplinesService = (invoiceNo) => {
  return baseUrl.get(
    `/claim/invoice/reprice/get/piplines?invoiceNo=${invoiceNo}`,
  );
};

export const getPipreasonCodeService = (invoiceNo) => {
  return baseUrl.get(`/claim/invoice/reprice/reasonCode/dropdown`);
};

export const getPipDescBillCodeService = (invoiceNo) => {
  return baseUrl.get(`/claim/pipLog/desc-bill`);
};

export const getPipSubCodeService = (invoiceNo) => {
  return baseUrl.get(`/claim/pipLog/sub-code`);
};

export const getPipInterestRateService = (body) => {
  return baseUrl.post(`/claim/pipLog/interest-rate`, body);
};

export const getProviderInfoService = (internalCode, fein) => {
  return baseUrl.get(
    `/claims/provider/view?internalCode=${internalCode}&fein=${fein}`,
  );
};

export const getProviderDetailsService = (
  internalCode,
  fein,
  isInvoice = false,
) => {
  if (!fein && !internalCode) {
  }
  if (isInvoice) {
    return baseUrl.get(
      `/claims/provider/view/details?fein=${fein}&isInvoice=${isInvoice}`,
    );
  } else {
    return baseUrl.get(
      `/claims/provider/view/details?internalCode=${internalCode}&fein=${fein}&isInvoice=${isInvoice}`,
    );
  }
};

export const requestCheckView = (body) => {
  return baseUrl.post(`/claim/claimant/requestChk/view`, body);
};

export const saveRequestChkService = (body) => {
  return baseUrl.post("/claim/claimant/requestChk/save", body);
};

export const getPipLogInfoService = (claimNo, claimantNo) => {
  return baseUrl.get(
    `/claim/pipLog/info/?claimNo=${claimNo}&claimantNo=${claimantNo}`,
  );
};

export const getDeductibleService = (body) => {
  return baseUrl.post(`/claim/pipLog/pipOptions/deductible/update`, body);
};
export const savePipLogService = (body) => {
  return baseUrl.post("/claim/pipLog/save", body);
};

export const printEobBillService = (claimNo, claimantNo, palmsInvNo) => {
  return baseUrl.post(
    `/claim/pipLog/print/eob`,
    {
      claimNo: claimNo,
      claimantNo: claimantNo,
      palmsInvNo: palmsInvNo,
    },
    {
      responseType: "blob",
    },
  );
};

//CLAIMS-198
export const printPipLogAllEobGenerateService = (body) => {
  return baseUrl.post(`/claim/pipLog/all/eob/generate`, body);
};

//CLAIMS-198
export const getPipLogPrintStatus = (processId) => {
  return baseUrl.get(`/claim/pipLog/status?processId=${processId}`);
};

//CLAIMS-198
export const getPipLogPrintFile = (processId) => {
  return baseUrl.get(`/claim/pipLog/all/eob/print?processId=${processId}`, {
    responseType: "blob",
  });
};

//CLAIMS-519
export const printPipBillService = (body) => {
  return baseUrl.post(`/claim/pipLog/generate`, body);
};

export const isPipBillDuplicate = (body) => {
  return baseUrl.post(`/claim/pipLog/pipBill/invoice/isDuplicate`, body);
};

export const printHcfaBillService = (claimNo, claimantNo, palmsInvNo) => {
  return baseUrl.post(
    //?claimNo=${claimNo}&claimantNo=${claimantNo}&palmsInvNo=${palmsInvNo}
    `claim/pipLog/pipBill/invoice/hcfa/view?palmsInvNo=${palmsInvNo}`,
    null,
    {
      responseType: "blob",
    },
  );
};

export const getPipBillInvoiceDeleteSerive = (claimNo, claimantNo, billKey) => {
  return baseUrl.delete(
    `/claim/pipLog/pipBill/invoice/delete?claimNo=${claimNo}&claimantNo=${claimantNo}&billKey=${billKey}`,
  );
};

export const viewPipBillPayBillService = (body) => {
  return baseUrl.post("/claim/pipLog/pipBill/invoice/payBill/view", body);
};

export const viewPipBillCheckIfWageLossService = (body) => {
  return baseUrl.post("/claim/pipLog/pipBill/invoice/checkIfWageLoss", body);
};

export const viewPipBillApyBillValidateService = (body) => {
  return baseUrl.post("/claim/pipLog/pipBill/invoice/payBill/validate", body);
};

export const viewPipBillCptListService = (body) => {
  return baseUrl.post("/claim/pipLog/pipBill/invoice/cpt/list", body);
};

export const savePipBillInvoiceService = (body) => {
  return baseUrl.post("/claim/pipLog/pipBill/invoice/save", body);
};

export const getClaimInvoicesSerive = () => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/payBill/matchToInvoice/view`,
  );
};

export const getPipBillInvoiceSerive = (claimNo, claimantNo, billKey) => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/get?claimNo=${claimNo}&claimantNo=${claimantNo}&billKey=${billKey}`,
  );
};

export const getMatchBillToPaymentSerive = (claimNo, claimantNo) => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/matchBillToPayment/view?claimNo=${claimNo}&claimantNo=${claimantNo}`,
  );
};

export const getPipBillPaymentsSerive = (claimNo, claimantNo, billKey) => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/payments/get?claimNo=${claimNo}&claimantNo=${claimantNo}&billKey=${billKey}`,
  );
  ///claim/pipLog/get/payemntsRecords
};

export const deletePayments = (body) => {
  let data = {
    indexIds: body,
  };
  return baseUrl.delete(`/claim/payment/check/batch/delete`, { data });
};

export const viewEobService = (selectedRow) => {
  return baseUrl.post(
    `/claim/payment/check/batch/view/eob?indexId=${selectedRow[0]}&perilDesc=${selectedRow[3]}`,
    null,
    {
      responseType: "blob",
    },
  );
};

export const printGridService = (body) => {
  return baseUrl.post("/claim/payment/check/batch/print", body, {
    responseType: "blob",
  });
};

export const viewHcfaService = (selectedRow) => {
  return baseUrl.post(
    `/claim/payment/check/batch/view/hcfa?indexId=${selectedRow[0]}&perilDesc=${selectedRow[3]}`,
    null,
    {
      responseType: "blob",
    },
  );
};

export const getRepricedPIPInvoicesSerive = (claimNo, claimantNo) => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/toMatchRepricedPIPInvoice/view?claimNo=${claimNo}&claimantNo=${claimantNo}`,
  );
};

export const selectRepricedPIPInvoicesSerive = (body) => {
  return baseUrl.post(
    `/claim/pipLog/pipBill/invoice/toMatchRepricedPIPInvoice/select`,
    body,
  );
};

export const selectPipPaymentSerive = (claimNo, claimantNo, billKey) => {
  return baseUrl.post(
    `/claim/pipLog/pipBill/invoice/matchBillToPayment/select?claimNo=${claimNo}&claimantNo=${claimantNo}&billKey=${billKey}`,
  );
};

export const selectClaimInvoicesSerive = (
  indexID,
  invoiceNo,
  isPIPpayment = false,
) => {
  return baseUrl.get(
    `/claim/pipLog/pipBill/invoice/payBill/matchToInvoice/select?indexID=${indexID}&invoiceNo=${invoiceNo}&isPIPpayment=${isPIPpayment}`,
  );
};

export const getClaimPipBills = (claimNo, claimantNo) => {
  return baseUrl.get(
    `/claim/pipLog/get/pipBills?claimNo=${claimNo}&claimantNo=${claimantNo}`,
  );
};

export const getClaimInfo = (claimNo) => {
  return baseUrl.get(`claim/details?claimNo=${claimNo}`);
};
export const preBulkService = (body) => {
  let data = {
    indexIds: body,
  };
  return baseUrl.post(`/claim/payment/check/batch/pre-bulk`, data, {
    responseType: "blob",
  });
};

export const generatePayment = (body) => {
  let indexIds = body;
  return baseUrl.post(`/claim/payment/generate`, { indexIds });
};

export const paymentStatusClaim = (body) => {
  let processId = body;
  return baseUrl.post(`/claim/payment/status`, { processId });
};

export const generatePdfByProcessId = (processId) => {
  return baseUrl.get(`/claim/payment/getPrint?processId=${processId}`, {
    responseType: "blob",
  });
};

export const getReturnBatch = (batchGuiId) => {
  return baseUrl.post(`account/get/payment/list?batchGuiId=${batchGuiId}`);
};

export const addPaymentService = (body) => {
  return baseUrl.post(`agent-csr/account/add/payments/to/batch`, body);
};

export const getPolicyDetails = (policyNo) => {
  return baseUrl.get(`agent-csr/policy/get/details?policyNo=${policyNo}`);
};

export const getPrintBatchDownload = (requestId) => {
  return baseUrl.get(
    `agent-csr/account/download/batch/report?requestId=${requestId}`,
  );
};
export const postBatchService = (body) => {
  return baseUrl.post(`agent-csr/account/post/to/batch`, body);
};

export const getDetailsByIndexId = (indexId) => {
  return baseUrl.get(
    `agent-csr/account/get/payment/details?indexId=${indexId}`,
  );
};

export const nextBatchNumber = (body) => {
  return baseUrl.post(`agent-csr/account/print/batch/report`, body);
};

export const getBatchId = () => {
  return baseUrl.get(`agent-csr/account/get/batch/no`);
};

export const checkFileStatus = (requestId) => {
  return baseUrl.get(
    `agent-csr/account/check/batch/report/status?requestId=${requestId}`,
  );
};

export const reverseEndorsementService = (policyNo) => {
  return baseUrl.post(
    `agent-csr/administration/reverseEndorsement?policyNo=${policyNo}`,
  );
};
export const getLocked = (claimNo, type) => {
  return baseUrl.get(`/claim/lock?recordNo=${claimNo}&type=${type}`);
};

export const getUnLocked = (claimNo, type) => {
  return baseUrl.get(`/claim/unlock?recordNo=${claimNo}&type=${type}`);
};

export const getWarnings = (claimNo) => {
  return baseUrl.get(`/claim/warning?claimNo=${claimNo}`);
};
// CLAIMS-865
export const printClaimsService = (body) => {
  return baseUrl.post(`/claim/generate?claimNo=${body.claimNo}`, {});
};

export const getClaimsPrintStatus = (processId) => {
  return baseUrl.get(`/claim/status?processId=${processId}`);
};

// CLAIMS-871
export const printAllClaimsService = (body) => {
  return baseUrl.post(`/claim/generate/DEC-DOL?claimNo=${body.claimNo}`, {});
};

//WorkFlow

export const getImageView = (indexId) => {
  let headers = {
    responseType: "blob",
    // responseType: "arraybuffer",
  };
  return baseUrl.get(`/download/document?indexID=${indexId}`, headers);
};

export const mgrOptionsService = (body) => {
  return baseUrl.post(`/claim/mgr-options`, body);
};

export const completeWorkFlowService = (indexId) => {
  return baseUrl.get(`claim/invoice/reprice/complete?indexId=${indexId}`);
};

export const getPrintOverNightSerivce = (checkNos) => {
  return baseUrl.post(
    `claim/payment/getPrintOverNight?checkNos=${checkNos}`,
    {},
  );
};

export const getRemovePrintOverNight = (checkNos) => {
  return baseUrl.post(
    `claim/payment/removePrintOverNight?checkNos=${checkNos}`,
    {},
  );
};

export const getVoidPaymentService = (body) => {
  return baseUrl.post(`claim/claimant/payments/void`, body);
};

export const getClaimsPaymentPDF = (body) => {
  return baseUrl.post(`claim/claimant/payments/print`, body, {
    responseType: "blob",
  });
};
export const getVoidPaymentChangeTypeService = (body) => {
  return baseUrl.post(`claim/claimant/payments/change/type`, body);
};



